import { generatePath } from 'react-router';

import {
  USER_PROFILE_ROUTE,
  ABOUT_PAGE_ROUTE,
  CLUB_PAGE_ROUTE,
  FAQ_PAGE_ROUTE,
  ADD_YOUR_COMPANY_PAGE_ROUTE,
  CONTACT_US_PAGE_ROUTE,
  INVESTMENT_OPPORTUNITIES,
} from 'client/constants/routes';
import { Language } from 'models/settings';

export const getMenuLinks = (lang: Language, withInvestmentOpportunities = false) => {
  const links = [
    { name: 'myProfile', link: generatePath(USER_PROFILE_ROUTE, { lang }) },
    { name: 'aboutUs', link: generatePath(ABOUT_PAGE_ROUTE, { lang }) },
    { name: 'clubPage', link: generatePath(CLUB_PAGE_ROUTE, { lang }) },
    { name: 'faq', link: generatePath(FAQ_PAGE_ROUTE, { lang }) },
    { name: 'addYourCompany', link: generatePath(ADD_YOUR_COMPANY_PAGE_ROUTE, { lang }) },
    { name: 'news', link: 'https://news.catalyst-ic.com/' },
    { name: 'contactUs', link: generatePath(CONTACT_US_PAGE_ROUTE, { lang }) },
  ];

  if (withInvestmentOpportunities)
    links.splice(1, 0, { name: 'investmentOpportunities', link: generatePath(INVESTMENT_OPPORTUNITIES, { lang }) });

  return links;
};
